import { addValidationRule } from 'formsy-react';

addValidationRule('moreThan', (values, value, field) => {
  return !isNaN(value) && !isNaN(field) && value > field;
});

addValidationRule('dateMoreThan', (values, value, field) => {
  if (!value || !field) {
    return true;
  }

  return value >= field;
});
